var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.6177 31.0152V9.83297C92.6177 6.02603 89.5917 3 85.7847 3H56.2077C53.3769 3 50.7414 4.07375 48.7891 6.12364L3.8867 51.026C2.32488 52.5878 2.32488 55.1258 3.8867 56.7853L38.9301 91.8286C40.4919 93.3905 43.0299 93.3905 44.6893 91.8286L92.6177 43.705M81.4897 23.6941C81.4897 28.9774 77.2068 33.2603 71.9236 33.2603C66.6403 33.2603 62.3574 28.9774 62.3574 23.6941C62.3574 18.4109 66.6403 14.128 71.9236 14.128C77.2068 14.128 81.4897 18.4109 81.4897 23.6941Z",
    stroke: "url(#paint0_linear_310_32844)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_310_32844",
    x1: 2.71533,
    y1: 48,
    x2: 92.6175,
    y2: 48.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D129DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CDBFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.593f0116a79e9b6e7e4ae4f57dcc9eb6.svg";
export { ForwardRef as ReactComponent };